import { CUSTOMER_JOURNEY_WEATHER_ERROR } from './../const';

function action() {
  return { type: CUSTOMER_JOURNEY_WEATHER_ERROR };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyWeatherError.js